import React from 'react';
import Notification from 'reapop';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { AnimatedSwitch } from 'react-router-transition';
import { connect } from 'react-redux';

import { compose } from 'shared/helpers';
import {
  GLOBAL_STYLE,
  OVERLAY_PORTAL_ROOT_ID,
  MASKING_PORTAL_ROOT_ID,
} from 'shared/constants/web';

import { mixClasses as cx } from 'helpers';
import { Navbar, Footer } from 'components/navs';
import { DecoratedRoute, DebugMonitor } from 'components/misc';
import { ErrorBoundary } from 'components/utils';
import { repopTheme } from 'helpers';


const AnimatedRouteSwitch = ({ routes }) => (
  <AnimatedSwitch
    atEnter={{opacity: 0}}
    atLeave={{opacity: 1}}
    atActive={{opacity: 1}}
  >
    {
      routes.map((routeProps, idx) => {
        const { path, redirect, ...rest } = routeProps;
        return (redirect
          ? <Redirect key={idx} from={path} to={redirect} {...rest} />
          : <DecoratedRoute key={idx} path={path} {...rest} />
        );
      })
    }
  </AnimatedSwitch>
);


function mapStateToProps(state) {
  return {
    notificationViewState: state.view.get('notification'),
  };
}


/*
 * App
 */
const App = ({
  notificationViewState: nvs,
  routes,
}) => {
  // TODO(tyu): Extract routes where nav render should ease in.
  const navShouldEaseIn = ['/'].includes(window.location.pathname);

  const topBarConStyle = (navShouldEaseIn ? {
    opacity: 0,
    animation: 'opacityFadeInFull 0.5s ease-in-out 1s 1 forwards',
  } : {});

  return (
    <div>
      <div
        className={cx(
          'fixed relative w-100 top-0',
          'z-5',  // Above overlay to show.
        )}
        style={topBarConStyle}
      >
        <DebugMonitor style={{ height: GLOBAL_STYLE.navbarDebugHeight }} />
        <Route component={Navbar} />
      </div>

      <ErrorBoundary>
        <div className="min-vh-100">
          <div className="absolute w-100">
            <AnimatedRouteSwitch routes={routes} />
          </div>
        </div>

        <div>
          <Route component={Footer} />
        </div>
      </ErrorBoundary>

      {/*
          Errors from portal seem to propagate through
          the parent component that created it, so they
          should be put in errory boundary there.
        */}
      <div id={OVERLAY_PORTAL_ROOT_ID} />
      <div id={MASKING_PORTAL_ROOT_ID} />

      <Notification theme={repopTheme} />
    </div>
  );
};


export default compose(
  // XXX: Link doesn't work w/o withRouter.. what? why??
  // Something to do with `history`..?
  withRouter,

  connect(mapStateToProps),
)(App);



// WEBPACK FOOTER //
// ./src/App.js